import React, { useRef, useState } from "react";

type Props = {
  onFile: (file: File) => void;
  uploading?: boolean;
  accept?: string;
};

export default function UploadDropzone({ onFile, uploading = false, accept = "image/*" }: Props) {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [dragOver, setDragOver] = useState(false);

  const handlePick = () => inputRef.current?.click();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) onFile(file);
    if (inputRef.current) inputRef.current.value = "";
  };
  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setDragOver(true);
  };
  const handleDragLeave = () => setDragOver(false);
  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer.files?.[0];
    if (file) onFile(file);
  };

  return (
    <div
      className={`h-[90px] w-[300px] rounded-[8px] border border-[#C8CDD4] grid place-items-center text-center text-xs text-[#83888E] ${
        dragOver ? "bg-gray-50" : ""
      } ${uploading ? "opacity-60 pointer-events-none" : "cursor-pointer"}`}
      onClick={handlePick}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <input ref={inputRef} type="file" accept={accept} className="sr-only" onChange={handleChange} />
      <div>
        <div className="mx-auto mb-1 h-8 w-8 rounded-full grid place-items-center bg-black text-[#1f2c22]">
          <span className="material-icons text-md text-primary">upload</span>
        </div>
        <span className="text-[#0f5132] font-medium">{uploading ? "Uploading…" : "Click to upload"}</span>
        {!uploading }
        <div>(max 800×400)</div>
      </div>
    </div>
  );
}
